import React from "react";
import { Link } from "react-router-dom";

export default function CompanyComponent(props) {
  const { id, company_logo, company_name } = props.item;
  const { path, handleUnfollow } = props;

  return (
    <div className="col-sm-3 actively_hiring">
      <div className="text-center">
        <div className="actively_hiring_img">
          {company_logo !== "" ? (
            <img
              src={path + encodeURI(company_logo)}
              className="img-fluid"
              alt={company_name}
            />
          ) : (
            <h4>{company_name}</h4>
          )}
        </div>
        {/* <Link to="" className="">
          00748 followers
        </Link>{" "}
        | */}
        <Link to="#" onClick={() => handleUnfollow(id)}>
          unfollow
        </Link>
      </div>
    </div>
  );
}
